import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Estábamos al borde de separarnos. Este manual nos dio herramientas concretas para hablar sin pelear. En una semana ya se sentía diferente.',
  author: 'Lucía y Martín',
  location: 'Buenos Aires',
  color: 'from-[#E8E0D4] to-[#D4C5B0]'
}, {
  text: 'Lo mejor es que es práctico. No es teoría, son cosas que aplicas esa misma noche.',
  author: 'Carolina R.',
  location: 'Córdoba',
  color: 'from-[#D4E0E5] to-[#A9C1CB]'
}, {
  text: 'El Contrato de Convivencia fue un antes y un después. Por primera vez sentimos que somos equipo.',
  author: 'Diego y Sofía',
  location: 'Rosario',
  color: 'from-[#F2D5C4] to-[#E5AB8E]'
}];
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#F5F0E8]" data-id="element-111">
      <div className="max-w-6xl mx-auto px-6" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-113">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4B5A] mb-20 text-center font-serif" data-id="element-114">
            Lo que dicen quienes ya lo aplicaron
          </h2>

          <div className="grid md:grid-cols-3 gap-8 md:gap-10" data-id="element-115">
            {testimonials.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-white rounded-3xl p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(27,75,90,0.08)] flex flex-col" data-id="element-116">
                <div className="flex gap-1 mb-8" data-id="element-117">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-[#E5A83B] fill-[#E5A83B]" data-id="element-118" />)}
                </div>

                <p className="text-[#2C2C2C] text-lg leading-relaxed mb-10 flex-1 font-sans italic" data-id="element-119">
                  "{item.text}"
                </p>

                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-[#E8E0D4]" data-id="element-120">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${item.color} flex-shrink-0`} data-id="element-121"></div>
                  <div data-id="element-122">
                    <p className="font-bold text-[#1B4B5A] font-sans" data-id="element-123">
                      {item.author}
                    </p>
                    <p className="text-sm text-[#7A7A6E] font-sans" data-id="element-124">
                      {item.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}